import Login from "../pages/auth/login";
import Login2 from "../pages/auth/login-2";
import OtpCode from "../pages/auth/OtpCode";
import Register from "../pages/auth/register";
import ForgetPassword from "../pages/auth/forget-password";
import ResetPassword from "../pages/auth/reset-password";
import VerifyEmail from "../pages/auth/verify-email";
import AdminLayout from "../layouts/adminLayout";
import Sample from "../pages/Sample";
import Print from "../pages/Print";

import { lazy } from "react";
import { AddFollowUpUser } from "../services";

const Dashboard = lazy(() => import("../pages/Dashboard"));

const UsersList = lazy(() => import("../pages/User/List"));
const UserNew = lazy(() => import("../pages/User/New"));
const UploadUserExcelFIle = lazy(() => import("../pages/User/UploadExcel"));
const UserEdit = lazy(() => import("../pages/User/Edit"));
const UserRole = lazy(() => import("../pages/User/UserRole"));
const RoleList = lazy(() => import("../pages/Role/List"));
const RoleNew = lazy(() => import("../pages/Role/New"));
const RoleEdit = lazy(() => import("../pages/Role/Edit"));
const UpdateRolePermission = lazy(() => import("../pages/Role/UpdateRolePermission"));
const UserNewByMarketer = lazy(() => import("../pages/User/NewByMarketer"));

const PermissionList = lazy(() => import("../pages/Permission/List"))
const PermissionNew = lazy(() => import("../pages/Permission/New"));
const PermissionEdit = lazy(() => import("../pages/Permission/Edit"))

const PermissionCategoryList = lazy(() => import("../pages/PermissionCategory/List"));
const PermissionCategoryNew = lazy(() => import("../pages/PermissionCategory/New"));
const PermissionCategoryEdit = lazy(() => import("../pages/PermissionCategory/Edit"));


const SampleCardList = lazy(() => import("../pages/SampleCard/List"));
const SampleCardNew = lazy(() => import("../pages/SampleCard/New"));
const SampleCardEdit = lazy(() => import("../pages/SampleCard/Edit"));



const SampleCardCategoryList = lazy(() => import("../pages/SampleCardCategory/List"));
const SampleCardCategoryNew = lazy(() => import("../pages/SampleCardCategory/New"));
const SampleCardCategoryEdit = lazy(() => import("../pages/SampleCardCategory/Edit"));

const SampleCardCompanyList = lazy(() => import("../pages/SampleCardCompany/List"));
const SampleCardCompanyNew = lazy(() => import("../pages/SampleCardCompany/New"));
const SampleCardCompanyEdit = lazy(() => import("../pages/SampleCardCompany/Edit"));


const UserJobList = lazy(() => import("../pages/UserJob/List"));
const UserJobNew = lazy(() => import("../pages/UserJob/New"));
const UserJobEdit = lazy(() => import("../pages/UserJob/Edit"));

const CityList = lazy(() => import("../pages/City/List"));
const CityNew = lazy(() => import("../pages/City/New"));
const CityEdit = lazy(() => import("../pages/City/Edit"));


const CancelCauseList = lazy(() => import("../pages/CancelCause/List"));
const CancelCauseNew = lazy(() => import("../pages/CancelCause/New"));
const CancelCauseEdit = lazy(() => import("../pages/CancelCause/Edit"));

const SaleStatusList = lazy(() => import("../pages/SaleStatus/List"));
const SaleStatusNew = lazy(() => import("../pages/SaleStatus/New"));
const SaleStatusEdit = lazy(() => import("../pages/SaleStatus/Edit"));

const CallStatusList = lazy(() => import("../pages/CallStatus/List"));
const CallStatusNew = lazy(() => import("../pages/CallStatus/New"));
const CallStatusEdit = lazy(() => import("../pages/CallStatus/Edit"));

const UserCategoryList = lazy(() => import("../pages/UserCategory/List"));
const UserCategoryNew = lazy(() => import("../pages/UserCategory/New"));
const UserCategoryEdit = lazy(() => import("../pages/UserCategory/Edit"));


const UserCategoryUploadUserExcelFIle = lazy(() => import("../pages/UserCategory/UploadExcel"));
const DistrictList = lazy(() => import("../pages/District/List"));
const DistrictNew = lazy(() => import("../pages/District/New"));
const DistrictEdit = lazy(() => import("../pages/District/Edit"));

const UserSatisfactionList = lazy(() => import("../pages/UserSatisfaction/List"));
const UserSatisfactionNew = lazy(() => import("../pages/UserSatisfaction/New"));
const UserSatisfactionEdit = lazy(() => import("../pages/UserSatisfaction/Edit"));

const MarketerUserCategoryList = lazy(() => import("../pages/Marketer/UserCategory/List"));
const RandomUserItem = lazy(() => import("../pages/Marketer/UserCategory/RandomUserItem"));
const Invoice = lazy(() => import("../pages/Marketer/UserCategory/Invoice"));
const InvoiceOnline = lazy(() => import("../pages/Marketer/UserCategory/CreateOnlineInvoice"));
const OnlineInvoice = lazy(() => import("../pages/Marketer/UserCategory/OnlineInvoice"));
const OnlineInvoiceList = lazy(() => import("../pages/Marketer/UserCategory/OnlineInvoiceList"));

const FollowUpUserList = lazy(() => import("../pages/Marketer/FollowUpUser/List"));
const FollowUpUserPersonalList = lazy(() => import("../pages/Marketer/FollowUpUser/List"));
const FollowUpUserNew = lazy(() => import("../pages/Marketer/FollowUpUser/New"));
const FollowUpUserPersonalNew = lazy(() => import("../pages/Marketer/FollowUpUser/New"));

const UserAddressList = lazy(() => import("../pages/UserAddress/List"));
const UserAddressNew = lazy(() => import("../pages/UserAddress/New"));
const UserAddressEdit = lazy(() => import("../pages/UserAddress/Edit"));

const CallHistoryList = lazy(() => import("../pages/Marketer/UserCategory/CallHistoryList"));
const UserChildListForMarketer = lazy(() => import("../pages/Marketer/UserCategory/UserChildList"));

const ChangeForcePassword = lazy(() => import("../pages/auth/changeForcePassword"));

const Test = lazy(() => import("../pages/Test/Test"));

const UserActivityReport = lazy(() => import("../pages/Report/UserActivity"));
const UserBlockReport = lazy(() => import("../pages/Report/UserBlock"));
const UserBlockListReport = lazy(() => import("../pages/Report/UserBlockList"));
const MarketerActivityListReport = lazy(() => import("../pages/Report/MarketerActivityList"));
const SaleReportForAccountantReport = lazy(() => import("../pages/Report/SaleReportForAccountant"));
const DetailSaleSupplierReport = lazy(() => import("../pages/Report/DetailSaleSupplierForAccountant"));
const TotalSaleSupplierForAccountantReport = lazy(() => import("../pages/Report/TotalSaleSupplierForAccountant"));
const DetailSaleMarketerReport = lazy(() => import("../pages/Report/DetailSaleMarketerForAccountant"));
const ReportRevokeCartByCasher = lazy(() => import("../pages/Report/ReportRevokeCartByCasher"));
const SaleSupplierForAdmin = lazy(() => import("../pages/Report/SaleSupplierForAdmin"));
const CardListReport = lazy(() => import("../pages/Report/CardList"));
const CardListWithDateReport = lazy(() => import("../pages/Report/CardListWithDate"));
const MarketerSaleIn30DayReport = lazy(() => import("../pages/Report/MarketerSaleIn30Day"));
const MarketerSaleIn30DayReportForAccountant = lazy(() => import("../pages/Report/MarketerSaleIn30DayForAccountant"));
const MarketerSaleIn30DayReportForSaleManagement = lazy(() => import("../pages/Report/MarketerSaleIn30DayForSaleManagement"));
const WebsiteSaleReport = lazy(() => import("../pages/Report/WebsiteSaleReport"));
const WebsiteSaleCardReport = lazy(() => import("../pages/Report/WebsiteSaleCardReport"));
const CustomerPurchaseHistoryListReport = lazy(() => import("../pages/Report/CustomerPurchaseHistoryList"));
const CustomerPurchaseHistoryDetailReport = lazy(() => import("../pages/Report/CustomerPurchaseHistoryDetail"));


const TotalSalePerMarketerForAccountantReport = lazy(() => import("../pages/Report/TotalSalePerMarketerForAccountantReport"));

const ReportDetailAcceptedSaleMarketerForAccountant = lazy(() => import("../pages/Report/DetailAcceptedSaleMarketerForAccountant"));
const ReportSupplierDeliveryCardPeriod = lazy(() => import("../pages/Report/SupplierDeliveryCardPeriod"));
const ReportDistrictBasketCountsWithDetail = lazy(() => import("../pages/Report/DistrictBasketCountsWithDetail"));


const DetailSaleForMarketerReport = lazy(() => import("../pages/Report/DetailSaleForMarketer"));

const MarketerBasketList = lazy(() => import("../pages/Marketer/Basket/MarketerBasketList"));
const MarketerBasketItem = lazy(() => import("../pages/Marketer/Basket/MarketerBasketItem"));
const SupplierAddressDeliveryReport = lazy(() => import("../pages/Supplier/Report/AddressDeliveryList"));
const SupplierAvailableCardListReport = lazy(() => import("../pages/Supplier/Report/AvailableCardList"));
const DetailSaleForSupplierReport = lazy(() => import("../pages/Supplier/Report/DetailSaleForSupplier"));

const MarketerRejectBasketList = lazy(() => import("../pages/Marketer/Basket/MarketerRejectBasketList"));

const UserChildList = lazy(() => import("../pages/UserChild/List"));
const UserChildNew = lazy(() => import("../pages/UserChild/New"));
const UserChildEdit = lazy(() => import("../pages/UserChild/Edit"));

const StreetList = lazy(() => import("../pages/Street/List"));
const StreetNew = lazy(() => import("../pages/Street/New"));
const StreetEdit = lazy(() => import("../pages/Street/Edit"));

const CardPackList = lazy(() => import("../pages/CardPack/List"));
const CardPackNew = lazy(() => import("../pages/CardPack/New"));
const CardPackEdit = lazy(() => import("../pages/CardPack/Edit"));

const SupplierList = lazy(() => import("../pages/Supplier/List"));
const SupplierEdit = lazy(() => import("../pages/Supplier/Edit"));
const SupplierCardList = lazy(() => import("../pages/Supplier/Card/SupplierCardList"));
const CurrentUserCardList = lazy(() => import("../pages/Supplier/SupplierCardList/List"));

const PaymentStatusList = lazy(() => import("../pages/PaymentStatus/List"));
const PaymentStatusNew = lazy(() => import("../pages/PaymentStatus/New"));
const PaymentStatusEdit = lazy(() => import("../pages/PaymentStatus/Edit"));

const BasketInDistrictSupplierList = lazy(() => import("../pages/Supplier/Basket/SupplierBasketList"));
const ConfirmerBasketList = lazy(() => import("../pages/Marketer/Basket/ConfirmerBasketList"));

const SupplierAcceptedBasketList = lazy(() => import("../pages/Supplier/Basket/SupplierAcceptedBasketList"));
const SupplierAcceptedBasketDetail = lazy(() => import("../pages/Supplier/Basket/SupplierBasketItem"));

const ReasonRejectList = lazy(() => import("../pages/ReasonReject/List"));
const ReasonRejectNew = lazy(() => import("../pages/ReasonReject/New"));
const ReasonRejectEdit = lazy(() => import("../pages/ReasonReject/Edit"));

const RevokeCard = lazy(() => import("../pages/Revoke/RevokeCard"))
const CardList = lazy(() => import("../pages/Card/List"))
const ChangeTowCardNumber = lazy(() => import("../pages/Card/ChangeTowCardNumber"))

const CardInformation = lazy(() => import("../pages/CardInformation/index"))
const BasketInfoWithBasketNumber = lazy(() => import("../pages/Report/BasketInfoWithBasketNumber"))


const BanksList = lazy(() => import("../pages/Bank/List"))


const ManagerAcceptedBasketDetail = lazy(() => import("../pages/Manager/Basket/ManagerBasketItem"));
const CardPackAcceptedForAccountantReport = lazy(() => import("../pages/Report/CardPackAcceptedForAccountantReport"));
const GetSupplierDistrictCountForAccountantReport = lazy(() => import("../pages/Report/GetSupplierDistrictCountForAccountantReport"));


const SalePolicyFilteringList = lazy(() => import("../pages/SalePolicyFiltering/List"));
const SalePolicyFilteringNew = lazy(() => import("../pages/SalePolicyFiltering/New"));
const SalePolicyFilteringEdit = lazy(() => import("../pages/SalePolicyFiltering/Edit"));

const GroupCityList = lazy(() => import("../pages/UserGroup/GroupCity/List"));
const GroupCityNew = lazy(() => import("../pages/UserGroup/GroupCity/New"));
const GroupCityEdit = lazy(() => import("../pages/UserGroup/GroupCity/Edit"));


const GroupGameTypeList = lazy(() => import("../pages/UserGroup/GroupGameType/List"));
const GroupGameTypeNew = lazy(() => import("../pages/UserGroup/GroupGameType/New"));
const GroupGameTypeEdit = lazy(() => import("../pages/UserGroup/GroupGameType/Edit"));

const GroupSchoolList = lazy(() => import("../pages/UserGroup/GroupSchool/List"));
const GroupSchoolNew = lazy(() => import("../pages/UserGroup/GroupSchool/New"));
const GroupSchoolEdit = lazy(() => import("../pages/UserGroup/GroupSchool/Edit"));

const GroupBasketList = lazy(() => import("../pages/UserGroup/GroupBasket/List"));
const GroupBasketNew = lazy(() => import("../pages/UserGroup/GroupBasket/New"));
const GroupBasketEdit = lazy(() => import("../pages/UserGroup/GroupBasket/Edit"));
const GroupBasketListDaily = lazy(() => import("../pages/UserGroup/GroupBasket/ListDaily"));
const GroupBasketShow = lazy(() => import("../pages/UserGroup/GroupBasket/Show"));
const GroupFinalBasketList = lazy(() => import("../pages/UserGroup/GroupBasket/FinalList"));
const GroupSchoolEmployeeList = lazy(() => import("../pages/GroupSchoolEmployee/List"));

//Dynamic User Category
const DynamicMarketerUserCategoryList = lazy(() => import("../pages/Marketer/DynamicUserCategory/List"));
const DynamicRandomUserItem = lazy(() => import("../pages/Marketer/DynamicUserCategory/RandomUserItem"));
const DynamicInvoice = lazy(() => import("../pages/Marketer/DynamicUserCategory/Invoice"));

//const MarketerBasketItem = lazy(() => import("../pages/Marketer/Basket/MarketerBasketItem"));
//const Invoice = lazy(() => import("../pages/Marketer/UserCategory/Invoice"));

export const mainRoute = [
    {
        id: 0,
        path: '/*',
        component: AdminLayout,
        isProtected: true
    },
    {
        id: 1,
        title: "ورود",
        path: '/login',
        component: Login,
        isProtected: false
    },
    {
        id: 10001,
        title: "ورود با رمز عبور",
        path: '/login-2',
        component: Login2,
        isProtected: false
    },
    {
        id: 10000,
        title: "اعتبارسنجی کد ورود",
        path: '/check/otp-code',
        component: OtpCode,
        isProtected: false
    },
    {
        id: 2,
        title: "ثبت نام",
        path: '/register',
        component: Register,
        isProtected: false
    },
    {
        id: 3,
        title: "فراموشی رمز عبور",
        path: '/forget-password',
        component: ForgetPassword,
        isProtected: false
    },
    {
        id: 4,
        title: "بازنشانی رمز عبور",
        path: '/reset-password',
        component: ResetPassword,
        isProtected: false
    },
    {
        id: 5,
        title: "تایید ایمیل",
        path: '/verify-email',
        component: VerifyEmail,
        isProtected: false
    },
    {
        id: 6,
        title: "تایید ایمیل",
        path: '/sample',
        component: Sample,
        isProtected: false
    },
    {
        id: 7,
        title: "چاپ فاکتور",
        path: '/print',
        component: Print,
        isProtected: false
    },
    {
        id: 8,
        title: "چاپ فاکتور",
        path: '/test',
        component: Test,
        isProtected: false
    }
]

export const panelRoutes = [
    {
        id: 0,
        title: "داشبورد",
        path: "/dashboard",
        component: Dashboard,
        permission: ""
    },
    {
        id: 1,
        title: "کاربران | لیست",
        path: "/user/list",
        component: UsersList,
        permission: "UserUserList"
    },
    {
        id: 2,
        title: "کاربران | جدید",
        path: "/user/new",
        component: UserNew,
        permission: "UserAddNewUser"
    },
    {
        id: 3,
        title: "کاربران | ویرایش",
        path: "/user/edit/:id",
        component: UserEdit,
        permission: "UserUserItem"
    },
    {
        id: 4,
        title: "کاربران | ویرایش نقش",
        path: "/user/user-role/:id",
        component: UserRole,
        permission: "UserUserItem"
    },
    {
        id: 5,
        title: "نقش ها | لیست",
        path: "/config/role/list",
        component: RoleList,
        permission: "RoleRoleList"
    },
    {
        id: 6,
        title: "نقش ها | جدید",
        path: "/config/role/new",
        component: RoleNew,
        permission: "RoleAddRole"
    },
    {
        id: 7,
        title: "نقش ها | ویرایش",
        path: "/config/role/edit/:id",
        component: RoleEdit,
        permission: "RoleGetRoleItem"
    },
    {
        id: 8,
        title: "سطح دسترسی نقش ها | ویرایش",
        path: "/config/role/update-permission/:id",
        component: UpdateRolePermission,
        permission: "RoleGetRoleItem"
    },
    {
        id: 9,
        title: "سطح دسترسی ها | لیست",
        path: "/config/permission/list",
        component: PermissionList,
        permission: "PermissionPermissionList"
    },
    {
        id: 10,
        title: "سطح دسترسی ها | جدید",
        path: "/config/permission/new",
        component: PermissionNew,
        permission: "PermissionAddPermission"
    },
    {
        id: 11,
        title: "سطح دسترسی ها | ویرایش",
        path: "/config/permission/edit/:id",
        component: PermissionEdit,
        permission: "PermissionGetPermissionItem"
    },
    {
        id: 12,
        title: "دسته بندی سطح دسترسی ها | لیست",
        path: "/config/permission-category/list",
        component: PermissionCategoryList,
        permission: "PermissionCategoryPermissionCategoryList"
    },
    {
        id: 13,
        title: "دسته بندی سطح دسترسی ها | جدید",
        path: "/config/permission-category/new",
        component: PermissionCategoryNew,
        permission: "PermissionCategoryAddPermissionCategory"
    },
    {
        id: 14,
        title: "دسته بندی سطح دسترسی ها | ویرایش",
        path: "/config/permission-category/edit/:id",
        component: PermissionCategoryEdit,
        permission: "PermissionCategoryPermissionCategoryItem"
    },
    {
        id: 15,
        title: "نمونه کارت ها | لیست",
        path: "/initial/sample-card/list",
        component: SampleCardList,
        permission: "SampleCardSampleCardList"
    },
    {
        id: 16,
        title: "نمونه کارت ها | ثبت",
        path: "/initial/sample-card/new",
        component: SampleCardNew,
        permission: "SampleCardAddSampleCard"
    },
    {
        id: 17,
        title: "دسته بندی نمونه کارت ها | ثبت",
        path: "/initial/sample-card-category/new",
        component: SampleCardCategoryNew,
        permission: "SampleCardCategoryAddSampleCardCategory"
    },
    {
        id: 18,
        title: "دسته بندی نمونه کارت ها | ویرایش",
        path: "/initial/sample-card-category/edit/:id",
        component: SampleCardCategoryEdit,
        permission: "SampleCardCategorySampleCardCategoryItem"
    },
    {
        id: 19,
        title: "دسته بندی نمونه کارت ها | لیست",
        path: "/initial/sample-card-category/list",
        component: SampleCardCategoryList,
        permission: "SampleCardCategorySampleCardCategoryList"
    },
    {
        id: 20,
        title: "شرکت های ارایه دهنده کارت | ثبت",
        path: "/initial/sample-card-company/new",
        component: SampleCardCompanyNew,
        permission: "SampleCardCategoryAddSampleCardCategory"
    },
    {
        id: 21,
        title: "شرکت های ارایه دهنده کارت | ویرایش",
        path: "/initial/sample-card-company/edit/:id",
        component: SampleCardCompanyEdit,
        permission: "SampleCardCompanyEditSampleCardCompany"
    },
    {
        id: 22,
        title: "شرکت های ارایه دهنده کارت | لیست",
        path: "/initial/sample-card-company/list",
        component: SampleCardCompanyList,
        permission: "SampleCardCompanySampleCardCompanyList"
    },
    {
        id: 23,
        title: "نمونه کارت ها | ویرایش",
        path: "/initial/sample-card/edit/:id",
        component: SampleCardEdit,
        permission: "SampleCardEditSampleCard"
    },
    {
        id: 24,
        title: "مشاغل | ویرایش",
        path: "/initial/user-job/edit/:id",
        component: UserJobEdit,
        permission: "UserJobEditUserJob"
    },
    {
        id: 25,
        title: "مشاغل | لیست",
        path: "/initial/user-job/list",
        component: UserJobList,
        permission: "UserJobUserJobList"
    },
    {
        id: 26,
        title: "مشاغل | ثبت",
        path: "/initial/user-job/new",
        component: UserJobNew,
        permission: "UserJobAddUserJob"
    },
    {
        id: 27,
        title: "کاربران | آپلود فایل اکسل",
        path: "/user/upload-excel",
        component: UploadUserExcelFIle,
        permission: "UserUploadExcelFile"
    },
    {
        id: 28,

        title: "بازاریاب | لیست دسته بندی ها",
        path: "/marketer/user-category/list",
        component: MarketerUserCategoryList,
        permission: "UserCategoryActiveUserCategoryList"
    },
    {
        id: 29,
        title: "شهرها | ویرایش",
        path: "/initial/city/edit/:id",
        component: CityEdit,
        permission: "CityEditCity"
    },
    {
        id: 30,
        title: "شهرها | لیست",
        path: "/initial/city/list",
        component: CityList,
        permission: "CityCityList"
    },
    {
        id: 31,
        title: "شهرها | ثبت",
        path: "/initial/city/new",
        component: CityNew,
        permission: "CityAddCity"
    },
    {
        id: 32,
        title: "علت لغو | ویرایش",
        path: "/initial/cancel-cause/edit/:id",
        component: CancelCauseEdit,
        permission: "CancelCauseEditCancelCause"
    },
    {
        id: 33,
        title: "علت لغو | لیست",
        path: "/initial/cancel-cause/list",
        component: CancelCauseList,
        permission: "CancelCauseCancelCauseList"
    },
    {
        id: 34,
        title: "علت لغو | ثبت",
        path: "/initial/cancel-cause/new",
        component: CancelCauseNew,
        permission: "CancelCauseAddCancelCause"
    },
    {
        id: 35,
        title: "وضعیت سفارش | ویرایش",
        path: "/initial/sale-status/edit/:id",
        component: SaleStatusEdit,
        permission: "SaleStatusEditSaleStatus"
    },
    {
        id: 36,
        title: "وضعیت سفارش | لیست",
        path: "/initial/sale-status/list",
        component: SaleStatusList,
        permission: "SaleStatusSaleStatusList"
    },
    {
        id: 37,
        title: "وضعیت سفارش | ثبت",
        path: "/initial/sale-status/new",
        component: SaleStatusNew,
        permission: "SaleStatusAddSaleStatus"
    },
    {
        id: 38,
        title: "وضعیت تماس | ویرایش",
        path: "/initial/call-status/edit/:id",
        component: CallStatusEdit,
        permission: "CallStatusEditCallStatus"
    },
    {
        id: 39,
        title: "وضعیت تماس | لیست",
        path: "/initial/call-status/list",
        component: CallStatusList,
        permission: "CallStatusCallStatusList"
    },
    {
        id: 40,
        title: "وضعیت تماس | ثبت",
        path: "/initial/call-status/new",
        component: CallStatusNew,
        permission: "CallStatusAddCallStatus"
    },
    {
        id: 41,
        title: "دسته بندی کاربران | ویرایش",
        path: "/initial/user-category/edit/:id",
        component: UserCategoryEdit,
        permission: "UserCategoryEditUserCategory"
    },
    {
        id: 42,
        title: "دسته بندی کاربران | لیست",
        path: "/initial/user-category/list",
        component: UserCategoryList,
        permission: "UserCategoryUserCategoryList"
    },
    {
        id: 43,
        title: "دسته بندی کاربران | ثبت",
        path: "/initial/user-category/new",
        component: UserCategoryNew,
        permission: "UserCategoryAddUserCategory"
    },
    {
        id: 44,
        title: "مناطق | ویرایش",
        path: "/initial/district/edit/:id",
        component: DistrictEdit,
        permission: "DistrictEditDistrict"
    },
    {
        id: 45,
        title: "مناطق | لیست",
        path: "/initial/district/list",
        component: DistrictList,
        permission: "DistrictDistrictList"
    },
    {
        id: 46,
        title: "مناطق | ثبت",
        path: "/initial/district/new",
        component: DistrictNew,
        permission: "DistrictAddDistrict"
    },
    {
        id: 45,
        title: "رضایتمندی | ویرایش",
        path: "/initial/user-satisfaction/edit/:id",
        component: UserSatisfactionEdit,
        permission: "UserSatisfactionEditUserSatisfaction"
    },
    {
        id: 45,
        title: "رضایتمندی | لیست",
        path: "/initial/user-satisfaction/list",
        component: UserSatisfactionList,
        permission: "UserSatisfactionUserSatisfactionList"
    },
    {
        id: 46,
        title: "رضایتمندی | ثبت",
        path: "/initial/user-satisfaction/new",
        component: UserSatisfactionNew,
        permission: "UserSatisfactionAddUserSatisfaction"
    },
    {
        id: 47,
        title: "اطلاعات مشتری",
        path: "/marketer/user-category/show/:id",
        component: RandomUserItem,
        permission: "UserRandomUserItem"
    },
    {
        id: 48,
        title: "پیگیری | لیست",
        path: "/marketer/user-followup/list",
        component: FollowUpUserList,
        permission: "FollowUpUserUserFollowUpList"
    },
    {
        id: 53,
        title: "شخصی | لیست",
        path: "/marketer/user-followup-personal/list",
        component: FollowUpUserPersonalList,
        permission: "FollowUpUserUserFollowUpList"
    },
    {
        id: 49,
        title: "لیست لاگ تماس ها | لیست",
        path: "/marketer/user-category/call-history-list",
        component: CallHistoryList,
        permission: "SaleGetDetailSaleService"
    },
    {
        id: 50,
        title: "فرزندان | ویرایش",
        path: "/initial/user-child/edit/:id",
        component: UserChildEdit,
        permission: "ChildUserChildItem"
    },
    {
        id: 51,
        title: "فرزندان | لیست",
        path: "/initial/user-child/list",
        component: UserChildList,
        permission: "ChildUserChildList"
    },
    {
        id: 52,
        title: "فرزندان | ثبت",
        path: "/initial/user-child/new",
        component: UserChildNew,
        permission: "ChildAddUserChild"
    },
    {
        id: 54,
        title: "آدرس کاربر | ویرایش",
        path: "/initial/user-address/edit/:id",
        component: UserAddressEdit,
        permission: "UserAddressEditUserAddress"
    },
    {
        id: 55,
        title: "آدرس کاربر | لیست",
        path: "/initial/user-address/list",
        component: UserAddressList,
        permission: "UserAddressUserAddressList"
    },
    {
        id: 56,
        title: "آدرس کاربر | ثبت",
        path: "/initial/user-address/new",
        component: UserAddressNew,
        permission: "UserAddressAddUserAddress"
    },
    {
        id: 57,
        title: "آدرس کاربر | ثبت",
        path: "/marketer/user-followup-personal/new",
        component: FollowUpUserPersonalNew,
        permission: "FollowUpUserAddMobileToFollowUpList"
    },
    {
        id: 58,
        title: "اطلاعات فرزندان | ثبت",
        path: "/marketer/user-category/user-child-list/:id",
        component: UserChildListForMarketer,
        permission: "FollowUpUserAddMobileToFollowUpList"
    },
    {
        id: 59,
        title: "ویرایش رمز عبور | ثبت",
        path: "/change-password",
        component: ChangeForcePassword,
        permission: "UserChangeUserPasswordByUser"
    },
    {
        id: 60,
        title: "گزارش فعالیت کاربران",
        path: "/report/user-activity",
        component: UserActivityReport,
        permission: "UserReportUserActivityReport"
    },
    {
        id: 61,
        title: "گزارش بلاک کاربران",
        path: "/report/user-block",
        component: UserBlockReport,
        permission: "UserReportCallStatusBlockList"
    },
    {
        id: 62,
        title: "لیست کاربران بلاک شده",
        path: "/report/user-block-list",
        component: UserBlockListReport,
        permission: "UserReportGetUserBlockList"
    },
    {
        id: 63,
        title: "فروش به مشتری خاص | جدید",
        path: "/new-by-marketer",
        component: UserNewByMarketer,
        permission: "UserCustomerInfoWithMobile"
    },
    {
        id: 64,
        title: "20 فعالیت آخر",
        path: "/report/marketer-activity",
        component: MarketerActivityListReport,
        permission: "UserReportMarketerActivityReport"
    }, {
        id: 65,
        title: "خیابان | ویرایش",
        path: "/initial/street/edit/:id",
        component: StreetEdit,
        permission: "StreetEditStreet"
    },
    {
        id: 66,
        title: "خیابان | لیست",
        path: "/initial/street/list",
        component: StreetList,
        permission: "StreetStreetList"
    },
    {
        id: 67,
        title: "خیابان | ثبت",
        path: "/initial/street/new",
        component: StreetNew,
        permission: "StreetAddStreet"
    }, {
        id: 68,
        title: "آپلود فایل اکسل",
        path: "/user-category/upload-excel",
        component: UserCategoryUploadUserExcelFIle,
        permission: "UserUploadExcelFile"
    }, {
        id: 69,
        title: "پک کارت | لیست",
        path: "/card-pack/list",
        component: CardPackList,
        permission: "CardGetCardPackList"
    },
    {
        id: 70,
        title: "پک کارت | ثبت",
        path: "/card-pack/new",
        component: CardPackNew,
        permission: "CardAddCardPack"
    }, {
        id: 71,
        title: "پک کارت | ویرایش",
        path: "/card-pack/edit/:id",
        component: CardPackEdit,
        permission: "CardEditCardPack"
    },
    {
        id: 72,
        title: "کارپرداز | لیست",
        path: "/supplier/list",
        component: SupplierList,
        permission: "UserSupplierList"
    },
    {
        id: 73,
        title: "کارپرداز | ویرایش",
        path: "/supplier/edit/:id",
        component: SupplierEdit,
        permission: "UserUserList"
    },
    {
        id: 74,
        title: "صورت حساب",
        path: "/marketer/invoice/show/:id",
        component: Invoice,
        permission: "UserRandomUserItem"
    },
    {
        id: 75,
        title: "وضعیت ارسال | لیست",
        path: "/initial/payment-status/list",
        component: PaymentStatusList,
        permission: "PaymentStatusPaymentStatusList"
    },
    {
        id: 76,
        title: "وضعیت ارسال | ثبت",
        path: "/initial/payment-status/new",
        component: PaymentStatusNew,
        permission: "PaymentStatusAddPaymentStatus"
    },
    {
        id: 77,
        title: "وضعیت ارسال | ویرایش",
        path: "/initial/payment-status/edit/:id",
        component: PaymentStatusEdit,
        permission: "PaymentStatusEditPaymentStatus"
    },
    {
        id: 78,
        title: "صورت حسابت",
        path: "/invoice/:id",
        component: Invoice,
        permission: "BasketCurrentBasket"
    },
    {
        id: 124,
        title: "صورت حسابت آنلاین",
        path: "invoice/online/:id",
        component: InvoiceOnline,
        permission: "BasketGetBasketByIdForSupplier"
    },
    {
        id: 124,
        title: "ویرایش حسابت آنلاین",
        path: "online/invoice/:id",
        component: OnlineInvoice,
        permission: "BasketGetBasketByIdForSupplier"
    },
    {
        id: 125,
        title: "لیست صورت حسابت آنلاین",
        path: "online/invoice/list",
        component: OnlineInvoiceList,
        permission: "BasketGetOnlineInvoiceListByMarketer"
    },
    {
        id: 79,
        title: "گزارش فروش بازاریاب",
        path: "/marketer/marketer-basket-list",
        component: MarketerBasketList,
        permission: "BasketBasketListFollowUpByMarketer"
    },
    {
        id: 80,
        title: "جزئیات فروش",
        path: "/marketer/marketer-basket-list/:id",
        component: MarketerBasketItem,
        permission: "BasketBasketListFollowUpByMarketer"
    },
    {
        id: 81,
        title: "لیست درخواست های",
        path: "/supplier/basket-district-list",
        component: BasketInDistrictSupplierList,
        permission: "BasketTodayByDistrictList"
    },
    {
        id: 82,
        title: "لیست قبول شده",
        path: "/supplier/supplier-accepted-basket-List",
        component: SupplierAcceptedBasketList,
        permission: "BasketGetSupplierAcceptedBasketList"
    },
    {
        id: 83,
        title: "جزئیات سبد خرید - کارپرداز",
        path: "/supplier/supplier-accepted-basket-List/:id",
        component: SupplierAcceptedBasketDetail,
        permission: "BasketBasketDetailForSupplier"
    },
    {
        id: 84,
        title: "دلایل در درخواست  | ویرایش",
        path: "/reason-reject/edit/:id",
        component: ReasonRejectEdit,
        permission: "ReasonsRejectEditResonReject"
    },
    {
        id: 85,
        title: "ثبت دلایل در درخواست | لیست",
        path: "/reason-reject/new",
        component: ReasonRejectNew,
        permission: "ReasonsRejectAddResonReject"
    },
    {
        id: 86,
        title: "لیست دلایل در درخواست | لیست",
        path: "/reason-reject/list",
        component: ReasonRejectList,
        permission: "ReasonsRejectReasonsRejectList"
    },
    {
        id: 87,
        title: "لیست کارت های کارپرداز | لیست",
        path: "/supplier/cardList",
        component: SupplierCardList,
        permission: "CardGetCardSupplierList"
    },
    {
        id: 88,
        title: "لیست کارت های کارپرداز | لیست",
        path: "/supplier/CurrentUserCardList",
        component: CurrentUserCardList,
        permission: "CardGetCardCurrentSupplierList"
    },
    {
        id: 89,
        title: "لبست کارت ها | لیست",
        path: "/card/card-list",
        component: CardList,
        permission: "CardCardList"
    },
    {
        id: 90,
        title: "ابطال کارت | لیست",
        path: "/revoke/revoke-card",
        component: RevokeCard,
        permission: "CardRevokeCardItemFromCashier"
    },
    {
        id: 91,
        title: "آدرس های کارپرداز | لیست",
        path: "/supplier/address-delivery-report/list",
        component: SupplierAddressDeliveryReport,
        permission: "UserReportGetSupplierDetailForHimSelf"
    },
    {
        id: 92,
        title: "کارت های دراختیار کارپرداز | لیست",
        path: "/supplier/available-card-list-report/list",
        component: SupplierAvailableCardListReport,
        permission: "UserReportSupplierDistrictList"
    },
    {
        id: 93,
        title: "گزارش فروش بازاریاب",
        path: "/marketer/marketer-reject-basket-list",
        component: MarketerRejectBasketList,
        permission: "UserReportGetRejectBasketSupplier"
    }, {
        id: 94,
        title: "گزارش فروش حسابدار",
        path: "/report/accountant-sale-report/list",
        component: SaleReportForAccountantReport,
        permission: "BasketGetSaleReportForAccountant"
    }, {
        id: 95,
        title: "گزارش فروش حسابدار",
        path: "/report/detail-sale-supplier/:id",
        component: DetailSaleSupplierReport,
        permission: "UserReportDetailSaleSupplierForAccountant"
    }, {
        id: 96,
        title: "گزارش فروش حسابدار",
        path: "/report/total-sale-supplier",
        component: TotalSaleSupplierForAccountantReport,
        permission: "UserReportTotalSaleSupplierForAccountant"
    },
    {
        id: 97,
        title: "لبست کارت ها | لیست",
        path: "/bank/list",
        component: BanksList,
        permission: "BankBankList"
    }, {
        id: 98,
        title: "گزارش فروش بازاریاب ها برای حسابدار",
        path: "/report/detail-sale-marketer",
        component: DetailSaleMarketerReport,
        permission: "UserReportTotalSaleMarketerForAccountant"
    }, {
        id: 99,
        title: "گزارش کلی کارپرداز",
        path: "/report/sale-supplier-for-admin",
        component: SaleSupplierForAdmin,
        permission: "UserReportSupplierActivity"
    },
    {
        id: 100,
        title: "گزارش فروش کارپرداز | لیست",
        path: "/supplier/detail-sale-supplier",
        component: DetailSaleForSupplierReport,
        permission: "UserReportGetSupplierDetailForHimSelf"
    }, {
        id: 101,
        title: "جابه جایی شماره کارت | لیست",
        path: "/card/change-tow-tCard-number",
        component: ChangeTowCardNumber,
        permission: "CardChangeTowCardNumber"
    }, {
        id: 102,
        title: "کارت های مجموعه",
        path: "/report/card-list",
        component: CardListReport,
        permission: "UserReportGetAllTypesOfCardsForAccounter"
    }, {
        id: 103,
        title: "گزارش فروش بازاریاب",
        path: "/report/detail-sale-marketer-report",
        component: DetailSaleForMarketerReport,
        permission: "UserReportTotalSaleMarketerForMarketer"
    }, {
        id: 104,
        title: "کارت های مجموعه با تاریخ",
        path: "/report/card-list-date",
        component: CardListWithDateReport,
        permission: "UserReportGetAllTypesOfCardsForAccounterWithDate"
    }, {
        id: 105,
        title: "گزارش 30 روزه بازاریاب",
        path: "/report/marketer-sale-30day",
        component: MarketerSaleIn30DayReport,
        permission: "UserReportGetMarketerSaleIn30Day"
    }, {
        id: 106,
        title: "گزارش 30 روزه بازاریاب",
        path: "/report/accepted-accountant-basket",
        component: ReportDetailAcceptedSaleMarketerForAccountant,
        permission: "UserReportGetAcceptedByAccountantBasketList"
    }, {
        id: 107,
        title: "جزئیات سبد خرید - مدیر",
        path: "/manager/manager-accepted-basket/:id",
        component: ManagerAcceptedBasketDetail,
        permission: "BasketGetCurrentBasketForAdmin"
    }, {
        id: 108,
        title: "کارت های تایید شده توسط حسابدار",
        path: "/user-report/card-pack-accepted-for-accountant-report",
        component: CardPackAcceptedForAccountantReport,
        permission: "UserReportGetAcceptedCardsByAccountantList"
    }, {
        id: 109,
        title: "مسیر های کارپرداز",
        path: "/user-report/supplier-district-count-report",
        component: GetSupplierDistrictCountForAccountantReport,
        permission: "UserReportGetSupplierDistrictCount"
    }, {
        id: 110,
        title: "گزارش فروش کلی بازاریاب ها",
        path: "/report/total-sale-per-marketer",
        component: TotalSalePerMarketerForAccountantReport,
        permission: "UserReportGetTotalSalePerMarketer"
    }, {
        id: 111,
        title: "گزارش 30 روزه بازاریاب - حسابداری",
        path: "/report/marketer-sale-30day-accountant",
        component: MarketerSaleIn30DayReportForAccountant,
        permission: "UserReportGetMarketerSaleIn30DayWithOutFinilized"
    },
    {
        id: 112,
        title: "ابطال کارت | لیست",
        path: "/card-information",
        component: CardInformation,
        permission: "CardInformationOfCard"
    }, {
        id: 113,
        title: "گزارش 30 روزه بازاریاب - حسابداری",
        path: "/report/marketer-sale-30day-sale-management",
        component: MarketerSaleIn30DayReportForSaleManagement,
        permission: "UserReportGetMarketerSaleIn30DayForSaleManagement"
    }, {
        id: 114,
        title: "مشتریان",
        path: "/report/customer-purchase-history",
        component: CustomerPurchaseHistoryListReport,
        permission: "UserReportGetCustomerPurchaseHistory"
    }, {
        id: 115,
        title: "جزئیات خرید مشتریان",
        path: "/report/customer-purchase-history-detail/:id",
        component: CustomerPurchaseHistoryDetailReport,
        permission: "UserReportGetCustomerPurchaseInfo"
    }, {
        id: 116,
        title: "گزارش نحوه تحویل کارت کارپرداز",
        path: "/report/supplier-delivery-period",
        component: ReportSupplierDeliveryCardPeriod,
        permission: "UserReportGetSupplierDeliveryCardPeriod"
    }, {
        id: 117,
        title: "جستجو شماره فاکتور",
        path: "/report/search-basket-with-number",
        component: BasketInfoWithBasketNumber,
        permission: "UserReportGetBasketInfoWithBasketNumber"
    }, {
        id: 118,
        title: "تعداد سفارش در منطقه",
        path: "/report/district-basket-counts-detail",
        component: ReportDistrictBasketCountsWithDetail,
        permission: "UserReportDistrictBasketCountsByDetail"
    }, {
        id: 119,
        title: "سیاست فروش | لیست",
        path: "/sale-policy-filtering/list",
        component: SalePolicyFilteringList,
        permission: "SalePolicyFilteringSalePolicyFilteringList"
    },
    {
        id: 120,
        title: "سیاست فروش | ثبت",
        path: "/sale-policy-filtering/new",
        component: SalePolicyFilteringNew,
        permission: "SalePolicyFilteringAddSalePolicyFiltering"
    }, {
        id: 121,
        title: "سیاست فروش | ویرایش",
        path: "/sale-policy-filtering/edit/:id",
        component: SalePolicyFilteringEdit,
        permission: "SalePolicyFilteringEditSalePolicyFiltering"
    },
    {
        id: 122,
        title: "اطلاعات مشتری",
        path: "/marketer/dynamic-user-category/show/:id",
        component: DynamicRandomUserItem,
        permission: "UserRandomUserItem"
    },
    {
        id: 123,
        title: "لیست درخواست های",
        path: "/marketer/confirm-basket-list/list",
        component: ConfirmerBasketList,
        permission: "BasketGetListBasketForConfirm"
    },
    {
        id: 126,
        title: "گزارش روزانه فروش وبسایت",
        path: "/report/website-sale-report",
        component: WebsiteSaleReport,
        permission: "UserReportGetWebsiteSaleReport"
    },
    {
        id: 127,
        title: "گزارش فروش کارت ها",
        path: "/report/website-sale-card-report",
        component: WebsiteSaleCardReport,
        permission: "UserReportGetWebsiteCardSaleReport"
    },
    {
        id: 24,
        title: "شهر های گروه | ویرایش",
        path: "/group/group-city/edit/:id",
        component: GroupCityEdit,
        permission: "GroupCityEditGroupCity"
    },
    {
        id: 25,
        title: "شهر های گروه | لیست",
        path: "/group/group-city/list",
        component: GroupCityList,
        permission: "GroupCityGetGroupCityList"
    },
    {
        id: 26,
        title: "شهر های گروه | ثبت",
        path: "/group/group-city/new",
        component: GroupCityNew,
        permission: "GroupCityAddGroupCity"
    },
    {
        id: 27,
        title: "توع بازی | ویرایش",
        path: "/group/group-game-type/edit/:id",
        component: GroupGameTypeEdit,
        permission: "GroupGameTypeEditGroupGameType"
    },
    {
        id: 28,
        title: "توع بازی | لیست",
        path: "/group/group-game-type/list",
        component: GroupGameTypeList,
        permission: "GroupGameTypeGroupGameTypeServiceList"
    },
    {
        id: 29,
        title: "توع بازی | ثبت",
        path: "/group/group-game-type/new",
        component: GroupGameTypeNew,
        permission: "GroupGameTypeAddGroupGameType"
    },
    {
        id: 30,
        title: "مدارس | ویرایش",
        path: "/group/group-school/edit/:id",
        component: GroupSchoolEdit,
        permission: "GroupSchoolEditGroupSchools"
    },
    {
        id: 31,
        title: "مدارس | لیست",
        path: "/group/group-school/list",
        component: GroupSchoolList,
        permission: "GroupSchoolGroupSchoolsServiceList"
    },
    {
        id: 32,
        title: "مدارس | ثبت",
        path: "/group/group-school/new",
        component: GroupSchoolNew,
        permission: "GroupSchoolAddGroupSchools"
    },
    {
        id: 33,
        title: "سفارش گروه | ویرایش",
        path: "/group/group-basket/edit/:id",
        component: GroupBasketEdit,
        permission: "GroupBasketEditGroupBasket"
    },
    {
        id: 34,
        title: "سفارش گروه | لیست",
        path: "/group/group-basket/list",
        component: GroupBasketList,
        permission: "GroupBasketGroupBasketList"
    },
    {
        id: 35,
        title: "سفارش گروه | ثبت",
        path: "/group/group-basket/new",
        component: GroupBasketNew,
        permission: "GroupBasketAddGroupBasket"
    },
    {
        id: 36,
        title: "سفارش گروه روزانه | لیست",
        path: "/group/group-basket-daily/list",
        component: GroupBasketListDaily,
        permission: "GroupBasketTodayGroupBaskets"
    }, {
        id: 37,
        title: "سفارش گروه | مشاهده",
        path: "/group/group-basket/show/:id",
        component: GroupBasketShow,
        permission: "GroupBasketGroupBasketItem"
    },
    {
        id: 38,
        title: "سفارش نهایی | لیست",
        path: "/group/group-basket-final/list-daily",
        component: GroupFinalBasketList,
        permission: "GroupBasketTodayGroupBaskets"
    },
    {
        id: 39,
        title: "مسئولین مدرسه | لیست",
        path: "/group/group-school-employees/list",
        component: GroupSchoolEmployeeList,
        permission: "GroupSchoolEmployeesGroupSchoolEmployeesListAll"
    },
    {
        id: 128,
        title: "گزارش ابطال صندوقدار ها",
        path: "/report/revoke-cart-casher",
        component: ReportRevokeCartByCasher,
        permission: "UserReportTotalSaleMarketerForAccountant"
    }
]
